import type { Translations } from '../../types'

const updatesMessages: Translations = {
  "updates.header.eyebrow": "Superadmin",
  "updates.header.title": "Updates",
  "updates.header.subtitle": "Centro operativo aggiornamenti per stato release e runtime.",
  "updates.actions.refresh": "Aggiorna",
  "updates.tabs.services": "Servizi",
  "updates.tabs.registrySettings": "Impostazioni registry",
  "updates.kpi.services": "Servizi verificati",
  "updates.kpi.available": "Aggiornamenti disponibili",
  "updates.kpi.blocked": "Aggiornamenti bloccati",
  "updates.auth.subtitle": "Sessione non valida",
  "updates.auth.message": "Accedi come superadmin per visualizzare la diagnostica release.",
  "updates.loading": "Caricamento stato release...",
  "updates.error.load": "Impossibile caricare lo stato aggiornamenti.",

  "updates.overview.title": "Panoramica release",
  "updates.overview.subtitle": "Dati manifest, canali e disponibilità artefatti della release corrente.",

  "updates.runtime.title": "Sintesi allineamento runtime",
  "updates.runtime.subtitle": "Verifica runtime rispetto ai target attesi per servizio.",
  "updates.runtime.globalStatus": "Stato complessivo",
  "updates.runtime.hero.aligned.title": "Sistema allineato",
  "updates.runtime.hero.aligned.description": "Tutti i servizi corrispondono alla release attesa.",
  "updates.runtime.hero.drift_detected.title": "Drift rilevato",
  "updates.runtime.hero.drift_detected.description": "Almeno un servizio differisce dalla release attesa.",
  "updates.runtime.hero.partial_data.title": "Dati runtime parziali",
  "updates.runtime.hero.partial_data.description": "Parte dei segnali runtime non è disponibile.",
  "updates.runtime.hero.unavailable.title": "Verifica runtime in attesa",
  "updates.runtime.hero.unavailable.description": "La copertura runtime è ancora troppo limitata per una verifica affidabile.",

  "updates.status.environment": "Ambiente",
  "updates.status.current": "Release corrente",
  "updates.status.previous": "Release precedente",
  "updates.status.failed": "Release fallita",
  "updates.status.refreshLabel": "Ultimo aggiornamento",
  "updates.status.notAvailable": "non disponibile",
  "updates.status.artifact.manifest": "Manifest",
  "updates.status.artifact.env": "Env",
  "updates.status.artifact.notes": "Note",
  "updates.status.artifact.present": "presente",
  "updates.status.artifact.missing": "assente",
  "updates.release.details.toggle": "Mostra dettagli release",

  "updates.notes.title": "Note release correnti",
  "updates.notes.subtitle": "Contenuto note associato alla release corrente.",
  "updates.notes.empty": "Nessuna nota release disponibile per la release corrente.",
  "updates.notes.actions.viewFull": "Apri note complete",
  "updates.notes.modal.title": "Note release",
  "updates.notes.modal.subtitle": "Contenuto completo della release corrente.",

  "updates.changelog.title": "Changelog release",
  "updates.changelog.subtitle": "Storico strutturato per release corrente, precedente e fallita.",
  "updates.changelog.actions.expand": "Espandi dettagli",

  "updates.drift.title": "Allerta sincronizzazione servizi",
  "updates.drift.description": "{{count}} servizio/i non sono sincronizzati con il rollout atteso. Verifica lo stato runtime prima delle azioni update.",
  "updates.drift.actions.inspect": "Rivedi servizi",
  "updates.drift.actions.rollback": "Valuta rollback",
  "updates.drift.healthy.title": "Runtime allineato",
  "updates.drift.healthy.description": "Nessun drift attivo rilevato. Il runtime risulta coerente con la release attesa.",

  "updates.actionsPanel.title": "Azioni operative",
  "updates.actionsPanel.subtitle": "Azioni deployment controllate tramite deployment-agent interno.",
  "updates.actionsPanel.checkUpdates": "Verifica update",
  "updates.actionsPanel.deployLatest": "Deploy latest",
  "updates.actionsPanel.openLogs": "Apri log",
  "updates.actionsPanel.rollback": "Rollback precedente",
  "updates.actionsPanel.inspectDrift": "Ispeziona servizi in drift",
  "updates.actionsPanel.plannerModeNote": "La modalità gestita dal planner abilita verifica update per servizio. I controlli legacy full-stack restano nascosti.",
  "updates.deployment.latest": "Ultima release",
  "updates.deployment.state": "Stato deployment",
  "updates.deployment.state.unavailable": "Non disponibile",
  "updates.deployment.state.idle": "In attesa",
  "updates.deployment.state.update_available": "Update disponibile",
  "updates.deployment.state.updateAvailable": "Update disponibile",
  "updates.deployment.state.checking": "Verifica update",
  "updates.deployment.state.deploying": "Deploy in corso",
  "updates.deployment.state.rolling_back": "Rollback in corso",
  "updates.deployment.state.rolled_back": "Rollback eseguito",
  "updates.deployment.state.failed": "Fallito",
  "updates.deployment.state.recovery_required": "Recovery richiesta",
  "updates.deployment.state.locked": "Bloccato",
  "updates.deployment.state.running": "In corso: {{phase}}",
  "updates.deployment.badge.updateAvailable": "Update disponibile",
  "updates.deployment.activeOperation": "{{type}} verso {{release}} richiesto da {{requestedBy}}",
  "updates.deployment.lastOperation": "Ultima operazione: {{status}} su {{release}}",
  "updates.deployment.correlationId": "Correlation ID",
  "updates.deployment.confirmDeploy": "Eseguire deploy della release {{release}}?",
  "updates.deployment.confirmRollback": "Eseguire rollback alla release {{release}}?",
  "updates.deployment.error.load": "Impossibile caricare lo stato deployment-agent.",
  "updates.deployment.error.action": "Azione deployment non riuscita.",
  "updates.deployment.agentUnavailable": "Deployment-agent non configurato per questo runtime.",
  "updates.deployment.recoveryRequired": "Recovery manuale richiesta prima di una nuova azione deployment.",
  "updates.deployment.toast.checked": "Verifica update completata",
  "updates.deployment.toast.deployStarted": "Deploy avviato per {{release}}",
  "updates.deployment.toast.rollbackStarted": "Rollback avviato per {{release}}",
  "updates.deployment.toast.completed": "Deployment completato",
  "updates.deployment.toast.rolledBack": "Deploy fallito e rollback completato",
  "updates.deployment.toast.failed": "Azione deployment fallita",

  "updates.history.title": "Storico release",
  "updates.history.subtitle": "Release immutabili recenti e marcatori di canale.",
  "updates.history.empty": "Nessun artefatto release disponibile.",
  "updates.history.badge.current": "corrente",
  "updates.history.badge.previous": "precedente",
  "updates.history.badge.failed": "fallita",
  "updates.history.deployedBy": "Deploy eseguito da",
  "updates.history.duration": "Durata",
  "updates.history.rollbackTarget": "Target rollback",

  "updates.services.title": "Stato runtime servizi",
  "updates.services.subtitle": "Stato runtime osservato e azionabilità update per servizio.",
  "updates.services.empty": "Nessun dato runtime disponibile.",
  "updates.services.columns.service": "Servizio",
  "updates.services.columns.expectedRelease": "Versione attesa",
  "updates.services.columns.runtimeRelease": "Versione runtime",
  "updates.services.columns.availableRelease": "Versione disponibile",
  "updates.services.columns.expectedSha": "SHA atteso",
  "updates.services.columns.runtimeRef": "Ref runtime",
  "updates.services.columns.health": "Salute",
  "updates.services.columns.alignment": "Stato",
  "updates.services.columns.status": "Stato servizio",
  "updates.services.columns.comparison": "Verifica runtime",
  "updates.services.columns.dependencies": "Dipendenze",
  "updates.services.columns.required": "Richiesti",
  "updates.services.columns.requiredNone": "Nessun servizio richiesto",
  "updates.services.columns.restart": "Riavvia con",
  "updates.services.columns.restartNone": "Nessuna dipendenza di riavvio",
  "updates.services.columns.lastSeen": "Ultima rilevazione",
  "updates.services.columns.updatedAt": "Aggiornato il",
  "updates.services.columns.updatedState": "Stato",
  "updates.services.columns.verification": "Verifica runtime",
  "updates.services.columns.expectedImage": "Immagine attesa",
  "updates.services.actions.expand": "Espandi riga servizio",
  "updates.services.actions.details": "Dettagli",
  "updates.services.actions.openDiagnostics": "Apri diagnostica",
  "updates.services.actions.preview": "Anteprima",
  "updates.services.bulk.selectAll": "Seleziona tutti gli aggiornamenti",
  "updates.services.bulk.selected": "{{selected}} di {{available}} selezionati",
  "updates.services.bulk.preview": "Anteprima piano",
  "updates.services.bulk.deploy": "Aggiorna selezionati",
  "updates.services.bulk.selectService": "Seleziona aggiornamento {{service}}",
  "updates.services.operational.pending": "in attesa",
  "updates.services.operational.updating": "aggiornamento",
  "updates.services.operational.restarting": "riavvio",
  "updates.services.operational.healthy": "sano",
  "updates.services.operational.failed": "fallito",
  "updates.services.operational.rolled_back": "rollback eseguito",
  "updates.services.operational.drift": "non sincronizzato",
  "updates.services.operational.missing": "mancante",
  "updates.services.operational.unknown": "da confermare",
  "updates.services.health.ok": "ok",
  "updates.services.health.degraded": "degradato",
  "updates.services.health.down": "non sano",
  "updates.services.health.unknown": "da confermare",
  "updates.services.alignment.aligned": "allineato",
  "updates.services.alignment.version_mismatch": "drift versione",
  "updates.services.alignment.unhealthy": "non sano",
  "updates.services.alignment.missing": "mancante",
  "updates.services.alignment.unknown": "da confermare",
  "updates.services.state.up-to-date": "sincronizzato",
  "updates.services.state.update-available": "update pronto",
  "updates.services.state.blocked": "verifica richiesta",
  "updates.services.state.unhealthy": "servizio degradato",
  "updates.services.state.unavailable": "stato da confermare",
  "updates.services.stateDetail.up-to-date": "Il runtime del servizio è sincronizzato con la versione target.",
  "updates.services.stateDetail.update-available": "Target {{expected}} · Runtime {{runtime}}.",
  "updates.services.stateDetail.blocked": "L'azione richiede verifica di dipendenze o controlli policy.",
  "updates.services.stateDetail.unhealthy": "I controlli di salute runtime risultano falliti.",
  "updates.services.stateDetail.unavailable": "Lo stato runtime di questo servizio è ancora da confermare.",
  "updates.services.comparison.aligned": "verificato",
  "updates.services.comparison.version-drift": "non sincronizzato",
  "updates.services.comparison.release-drift": "riferimento release non coerente",
  "updates.services.comparison.missing-runtime": "verifica runtime richiesta",
  "updates.services.comparison.unknown-runtime-release": "release runtime non risolta",
  "updates.services.comparison.missing-labels": "metadati runtime incompleti",
  "updates.services.comparison.unknown": "verifica in attesa",
  "updates.services.comparisonDetail.aligned": "La verifica runtime è allineata alla release desiderata.",
  "updates.services.comparisonDetail.version-drift": "Desiderata {{desired}} · Runtime {{runtime}}.",
  "updates.services.comparisonDetail.release-drift": "La release ID differisce dal target selezionato. Runtime {{runtime}} · Release {{releaseId}}.",
  "updates.services.comparisonDetail.missing-runtime": "Lo stato runtime non è stato ispezionato per questo servizio.",
  "updates.services.comparisonDetail.unknown-runtime-release": "La release ID runtime non è associata a una release pubblicata nota.",
  "updates.services.comparisonDetail.missing-labels": "I metadati runtime dell'immagine sono incompleti per una verifica affidabile.",
  "updates.services.comparisonDetail.unknown": "I dati di verifica runtime sono incompleti.",
  "updates.services.status.ok": "ok",
  "updates.services.status.drift": "drift",

  "updates.services.details.title": "Dettaglio servizio",
  "updates.services.details.section.status": "Stato",
  "updates.services.details.section.version": "Versione",
  "updates.services.details.section.diagnostics": "Diagnostica",
  "updates.services.details.section.actions": "Azioni",
  "updates.services.details.driftMessage": "Il servizio è in drift: la versione runtime non corrisponde alla release attesa.",
  "updates.services.details.actions.openLogs": "Apri log",
  "updates.services.details.actions.copyDiagnosis": "Copia diagnosi",
  "updates.services.details.explanation.title": "Diagnostica",
  "updates.services.details.explanation.aligned": "Servizio allineato alla release attesa.",
  "updates.services.details.explanation.version_mismatch": "La versione runtime non corrisponde alla release attesa.",
  "updates.services.details.explanation.release_drift": "La release runtime differisce dalla release desiderata del servizio.",
  "updates.services.details.explanation.unknownRuntimeRelease": "La release runtime non è riconosciuta dallo store release.",
  "updates.services.details.explanation.missingLabels": "L'immagine runtime non contiene uno o più label richiesti.",
  "updates.services.details.explanation.unhealthy": "Il servizio risulta non sano: verificare health checks e dipendenze.",
  "updates.services.details.explanation.missing": "Nessun runtime osservato per questo servizio.",
  "updates.services.details.explanation.unknown": "Dati runtime insufficienti per una diagnosi completa.",
  "updates.services.details.fields.expectedShortSha": "SHA atteso",
  "updates.services.details.fields.expectedReleaseId": "Release ID attesa",
  "updates.services.details.fields.expectedVersion": "Versione attesa",
  "updates.services.details.fields.expectedImage": "Immagine attesa",
  "updates.services.details.fields.runtimeVersion": "Versione runtime",
  "updates.services.details.fields.runtimeRef": "Ref runtime",
  "updates.services.details.fields.runtimeReleaseId": "Release ID runtime",
  "updates.services.details.fields.availableVersion": "Versione disponibile",
  "updates.services.details.fields.comparison": "Confronto",
  "updates.services.details.fields.alignment": "Allineamento",
  "updates.services.details.fields.health": "Salute",
  "updates.services.details.fields.diagnostics": "Diagnostica",
  "updates.services.details.fields.actions": "Azioni",
  "updates.services.details.fields.dependencies": "Dipendenze",
  "updates.services.details.fields.restartWith": "Riavvia con",

  "updates.runtime.mode.missing": "verifica runtime in attesa",
  "updates.runtime.mode.partial": "runtime parziale",
  "updates.runtime.mode.uniform": "runtime coerente",
  "updates.runtime.mode.mixed-version": "mixed-version",
  "updates.runtime.banner.missing.title": "Verifica runtime in attesa",
  "updates.runtime.banner.missing.description": "La copertura runtime è al momento limitata. Le operazioni per servizio restano disponibili dove possibile.",
  "updates.runtime.banner.partial.title": "Metadati runtime incompleti",
  "updates.runtime.banner.partial.description": "Alcune label, immagini o release ID mancano. Le righe per servizio vengono mostrate quando disponibili.",
  "updates.runtime.banner.uniform.title": "Runtime uniforme",
  "updates.runtime.banner.uniform.description": "Tutti i servizi osservati condividono la stessa versione runtime.",
  "updates.runtime.banner.mixed-version.title": "Runtime mixed-version",
  "updates.runtime.banner.mixed-version.description": "Può essere atteso con aggiornamenti selettivi e richiede verifica per servizio.",

  "updates.system.requiresAttention": "Richiesta attenzione",
  "updates.system.verificationRequested": "Verifica richiesta",
  "updates.system.status.healthy": "sano",
  "updates.system.status.update-available": "update disponibile",
  "updates.system.status.runtime-partial": "runtime parziale",
  "updates.system.status.runtime-unavailable": "runtime non disponibile",
  "updates.system.status.deployment-inconsistent": "deployment incoerente",
  "updates.system.status.degraded": "degradato",
  "updates.system.title.healthy": "Sistema operativo",
  "updates.system.title.update-available": "Sistema operativo con update disponibili",
  "updates.system.title.runtime-partial": "Verifica runtime incompleta",
  "updates.system.title.runtime-unavailable": "Verifica runtime non disponibile",
  "updates.system.title.deployment-inconsistent": "Stato deployment incoerente",
  "updates.system.title.degraded": "Sistema degradato",
  "updates.system.description.healthy": "Segnali runtime e deployment stabili. Nessun intervento immediato richiesto.",
  "updates.system.description.update-available": "Runtime stabile e almeno un update servizio verificato disponibile.",
  "updates.system.description.runtime-partial": "Alcuni segnali runtime sono ancora da confermare. Le operazioni update restano disponibili con verifica per servizio.",
  "updates.system.description.runtime-unavailable": "La copertura di verifica runtime è al momento insufficiente. Aggiorna i controlli runtime prima di azioni ad alto impatto.",
  "updates.system.description.deployment-inconsistent": "Lo stato deployment richiede verifica manuale o recovery prima di nuove azioni.",
  "updates.system.description.degraded": "Uno o più servizi richiedono attenzione prima di operazioni update sicure.",

  "updates.diagnostics.title": "Diagnostica tecnica",
  "updates.diagnostics.subtitle": "Evidenze dettagliate planner/runtime per debugging operativo.",
  "updates.diagnostics.runtime": "Diagnostica runtime",
  "updates.diagnostics.verification": "Diagnostica verifica aggiornamenti",
  "updates.diagnostics.planner": "Diagnostica planner e dipendenze",
  "updates.diagnostics.operations": "Diagnostica operazioni deployment",
  "updates.diagnostics.messages.runtimeMissingImage": "Immagine runtime non rilevata: {{services}}",
  "updates.diagnostics.messages.labelsMissing": "Metadati runtime incompleti: {{services}}",
  "updates.diagnostics.messages.runtimeUnknownRelease": "Release runtime non risolta: {{services}}",
  "updates.diagnostics.messages.runtimeMixedVersion": "Rilevate più versioni runtime: {{versions}}",
  "updates.diagnostics.messages.runtimeMixedRelease": "Rilevati più release ID runtime: {{releases}}",
  "updates.diagnostics.messages.imageReferenceMissing": "Riferimento immagine runtime mancante: {{services}}",
  "updates.diagnostics.messages.imageInspectFailed": "Ispezione immagine runtime fallita: {{services}}",
  "updates.diagnostics.messages.digestOnlyRuntimeImage": "Immagine runtime solo digest: {{services}}",
  "updates.diagnostics.messages.updatesCheckFailed": "Verifica aggiornamenti fallita: {{reason}}",

  "updates.preview.section.title": "Preview piano",
  "updates.preview.actions.run": "Preview piano",
  "updates.preview.actions.loading": "Caricamento preview...",
  "updates.preview.empty": "Esegui la preview per vedere l'impatto senza deploy.",
  "updates.preview.fields.targetVersion": "Versione target",
  "updates.preview.fields.status": "Stato preview",
  "updates.preview.fields.rollbackSafe": "Rollback safe",
  "updates.preview.fields.migration": "Warning migrazione",
  "updates.preview.fields.willUpdate": "Servizi aggiornati",
  "updates.preview.fields.willRestart": "Servizi riavviati",
  "updates.preview.values.safe": "sicuro",
  "updates.preview.values.unsafe": "non sicuro",
  "updates.preview.deploy.confirm": "Aggiorna",
  "updates.preview.deploy.loading": "Aggiornamento in corso...",
  "updates.preview.deploy.started": "Aggiornamento avviato per {{service}}",
  "updates.preview.deploy.requiresPreview": "Esegui prima il preview piano.",
  "updates.preview.deploy.planBlocked": "Il preview piano non è pronto per l'aggiornamento.",
  "updates.preview.deploy.blocked": "L'aggiornamento è bloccato per questo servizio.",
  "updates.preview.deploy.unavailable": "L'aggiornamento non è disponibile per questo servizio.",
  "updates.preview.deploy.executorUnavailable": "L'executor deployment non è disponibile per gli update planner.",

  "updates.globalStatus.aligned": "allineato",
  "updates.globalStatus.drift_detected": "drift rilevato",
  "updates.globalStatus.partial_data": "dati parziali",
  "updates.globalStatus.unavailable": "non disponibile",

  "updates.summary.aligned": "Servizi allineati",
  "updates.summary.mismatch": "Drift versione",
  "updates.summary.unhealthy": "Servizi non sani",
  "updates.summary.missing": "Servizi mancanti",

  "updates.artifact.releaseId": "Release ID",
  "updates.artifact.gitSha": "Git SHA",
  "updates.artifact.createdAt": "Creato il",
  "updates.artifact.dbChangeType": "Tipo change DB",
  "updates.artifact.rollbackSafe": "Rollback safe",
  "updates.artifact.manifestPath": "Percorso manifest",
  "updates.artifact.notesPath": "Percorso note",
  "updates.release.buildFromTimestamp": "Build {{timestamp}}",
  "updates.release.buildFromSha": "Build {{sha}}",
  "updates.release.buildUnknown": "Metadata build non disponibili",

  "updates.operation.sheet.title": "Operazione deployment",
  "updates.operation.sheet.titleActive": "Operazione {{type}}",
  "updates.operation.sheet.title.deploy": "Deploy latest",
  "updates.operation.sheet.title.rollback": "Rollback precedente",
  "updates.operation.sheet.title.check": "Verifica update",
  "updates.operation.sheet.subtitle": "Dettaglio operazione deployment-agent.",
  "updates.operation.sheet.subtitleIntent": "Prepara operazione per {{release}}.",
  "updates.operation.sheet.subtitleOperation": "Operazione in corso per {{release}}.",
  "updates.operation.confirm.title": "Conferma operazione",
  "updates.operation.confirm.description": "L'operazione sarà eseguita dal deployment-agent per {{release}}.",
  "updates.operation.confirm.run": "Esegui operazione",
  "updates.operation.meta.operationId": "Operation ID",
  "updates.operation.meta.correlationId": "Correlation ID",
  "updates.operation.meta.requestedBy": "Richiesto da",
  "updates.operation.meta.status": "Stato",
  "updates.operation.meta.fromRelease": "Da release",
  "updates.operation.meta.toRelease": "A release",
  "updates.operation.meta.startedAt": "Avvio",
  "updates.operation.meta.finishedAt": "Fine",
  "updates.operation.meta.duration": "Durata",
  "updates.operation.header.secondaryMeta": "Altri metadati",
  "updates.operation.failure.title": "Operazione fallita",
  "updates.operation.failure.rollback": "Rollback ripristinato a {{release}}.",
  "updates.operation.timeline.title": "Attività deployment",
  "updates.operation.timeline.unavailable": "Nessun evento fase disponibile dal deployment-agent.",
  "updates.operation.phaseState.active": "attiva",
  "updates.operation.phaseState.completed": "completata",
  "updates.operation.phaseState.failed": "fallita",
  "updates.operation.phaseState.pending": "in attesa",
  "updates.operation.phase.preparing": "preparazione release",
  "updates.operation.phase.activating_release": "attivazione release",
  "updates.operation.phase.pulling_images": "pull immagini",
  "updates.operation.phase.wave_1": "deploy wave 1",
  "updates.operation.phase.health_gate_wave_1": "health gate wave 1",
  "updates.operation.phase.wave_2": "deploy wave 2",
  "updates.operation.phase.health_gate_wave_2": "health gate wave 2",
  "updates.operation.phase.verification": "verifica",
  "updates.operation.phase.completed": "deployment completato",
  "updates.operation.phase.rollback": "rollback",
  "updates.operation.phase.services": "Servizi collegati",
  "updates.operation.phase.raw": "Estratto raw",
  "updates.operation.verification.title": "Verifica",

  "updates.values.yes": "Sì",
  "updates.values.no": "No",
  "updates.common.close": "Chiudi",
}

export default updatesMessages
